import { render, staticRenderFns } from "./VTh.vue?vue&type=template&id=3bd0f4a5&scoped=true&"
import script from "./VTh.vue?vue&type=script&lang=js&"
export * from "./VTh.vue?vue&type=script&lang=js&"
import style0 from "./VTh.vue?vue&type=style&index=0&id=3bd0f4a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd0f4a5",
  null
  
)

export default component.exports